<button type="button" class="btn btn-outline-danger" (click)="resetFilterData()">Reset Filters</button>
